<template>
  <div class="l-page l-page--message">

    <main class="l-main">
      <!-- パンくずリスト -->
      <breadcrumb :breadcrumb-data="breadcrumbData" />
      <!-- /パンくずリスト -->

      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">カスタムパラメーター{{ title }}</div>
        </div>
      </div>

      <!-- ユーザー情報入力エリア -->
      <form @submit.prevent>
        <div class="l-main-content">
          <div class="p-project-edit">
            <div class="c-title c-title--left">
              <div class="c-title__text u-fs24"></div><br />
            </div>
            <div class="p-project-edit-list p-project-edit-list--first">
              <div class="p-project-edit-list__item">
                <div class="c-input__title">パラメータ種別</div>
                <select-text
                  ref="parameterTypeSelect"
                  input-name="parameter_type"
                  place-holder="パラメーター種別を選択してください"
                  :value="customParameter.parameterType"
                  :classes="['u-w450']"
                  :elements="parameterTypes"
                  @select="onTypeSelect"
                />
              </div>
              <div class="p-project-edit-list__item">
                <validatable-text-input
                  :input-name="'customParameter.parameterValue'"
                  :title="'パラメーター設定'"
                  :placeholder="'パラメーター設定を入力してください'"
                  :data="customParameter.parameterValue"
                  :error-message="getErrorMessage('customParameter.parameterValue')"
                  @value-changed="customParameter.parameterValue = $event"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="l-main-content">
          <!-- ボタンエリア -->
          <div class="p-team-btns" style="margin-bottom: 40px;">
            <a class="c-btn c-btn--gray u-w320" @click="onQuitClick()">
              <p class="c-btn__text">キャンセル</p>
            </a>
            <button
              class="c-btn c-btn--blue u-w320"
              :class="{ 'is-loading': isLoadingSaveBtn }"
              :disabled="isLoadingSaveBtn"
              type="button"
              name="add"
              value="add-user"
              @click="save()"
            >
              <p class="c-btn__text">{{ buttonLabel }}する</p>
            </button>
          </div>
          <!-- /ボタンエリア -->
        </div>
      </form>
    </main>

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />

    <!-- モーダル: 配信グループ設定完了メッセージ表示 -->
    <control-modal
      ref="refCompleteModal"
      classes="c-modal--result"
      :body="completeMessage"
      cancel-button-label="一覧へ"
      :is-active=isCompleteMessage
      :on-close-click="onCloseControlModal"
      :on-cancel-click="onCancelControlModal"
    />

  </div>
</template>

    <script>
import axios from 'axios';

const UTM_PARAMETER_TYPE = '1';

export default {
  props: {
    mode: String,
    breadcrumbData: Array,
    customParameterInfo: Object,
  },
  data: function () {
    return {
      isLoadingSaveBtn: false,
      isError: false,
      errorMessage: '',
      errorMessages: {},
      completeMessage: '',
      isCompleteMessage: false,
      parameterTypes: this.customParameterInfo.parameter_types || {},
      customParameterId: '',
      customParameter: {
        parameterType: this.customParameterInfo.parameter_type || UTM_PARAMETER_TYPE,
        parameterValue: this.customParameterInfo.parameter_value || '',
      }
    };
  },
  computed: {
    title: function() {
      return this.mode === 'add' ? '登録' : '編集';
    },
    buttonLabel: function() {
      return this.mode === 'add' ? '登録' : '更新';
    },
  },
  mounted: function() {
  },
  methods: {
    validate: function () {
      this.errorMessages = {};
      let isValid = true;
      if (this.customParameter.parameterType === '') {
        this.errorMessages['customParameter.parameterType'] = 'パラメーター種別を選択してください。';
        isValid = false;
      }
      if (this.customParameter.parameterValue === '') {
        this.errorMessages['customParameter.parameterValue'] = 'パラメーター設定を入力してください。';
        isValid = false;
      }
      // utmパラメーターの場合、key=value形式で入力されているかチェック
      if (this.customParameter.parameterType == UTM_PARAMETER_TYPE) {
        const pattern = /^(&?[^=&]+=[^&]*)(&([^=&]+=[^&]*))*$/;
        if (!pattern.test(this.customParameter.parameterValue)) {
          this.errorMessages['customParameter.parameterValue'] = 'パラメーター設定は「key=value」形式で入力してください。';
          isValid = false;
        }
      }
      return isValid;
    },
    save: function () {

      if (this.validate() === false) {
        return;
      }

      this.isLoadingSaveBtn = true;
      const params = {
        parameter_type: this.customParameter.parameterType,
        parameter_value: this.customParameter.parameterValue,
      };
      if (this.customParameterInfo.custom_parameter_id) {
        params.custom_parameter_id = this.customParameterInfo.custom_parameter_id;
      }
      axios.post('/api/custom-parameter/save', params)
        .then((response) => {
          this.isLoadingSaveBtn = false;
          if (response.data.result === 'OK') {
            this.completeMessage = `カスタムパラメーターを${ this.buttonLabel} しました。`;
            this.isCompleteMessage = true;
          } else {
            this.errorMessage = response.data.message;
            this.isError = true;
          }
        })
        .catch((_error) => {
          this.isLoadingSaveBtn = false;
          this.errorMessage = 'エラーが発生しました。';
          this.isError = true;
        });
    },
    onTypeSelect: function(selected) {
      this.customParameter.parameterType = selected;
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    // クリック: 完了モーダルを閉じる処理
    onCloseControlModal() {
      this.isCompleteMessage = false;
    },
    // クリック: 完了モーダルを閉じる処理
    onCancelControlModal() {
      this.isCompleteMessage = false;
      location.href = "/coins-admin/custom-parameter";
    },
    // クリック: 作成キャンセル
    onQuitClick: function() {
      location.href = '/coins-admin/custom-parameter';
    },
    getErrorMessage: function (key) {
      return this.errorMessages[key];
    },
  }
}
    </script>